import { render } from "./AgendaView.vue?vue&type=template&id=28f069ac&ts=true"
import script from "./AgendaView.vue?vue&type=script&lang=ts"
export * from "./AgendaView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__